import { render, staticRenderFns } from "./BuildCard.vue?vue&type=template&id=2d3becfe&scoped=true&"
import script from "./BuildCard.vue?vue&type=script&lang=js&"
export * from "./BuildCard.vue?vue&type=script&lang=js&"
import style0 from "./BuildCard.vue?vue&type=style&index=0&id=2d3becfe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3becfe",
  null
  
)

export default component.exports